<article #card class="resource-tray-card">
  <div class="resource-tray-card-main">
    <div #metadata class="resource-tray-card-metadata">
      <ng-content select="[tray-card-content]"></ng-content>
    </div>
    <aside class="resource-tray-command-tray" aria-label="Card commands">
      <ng-content select="[tray-card-command]"></ng-content>
    </aside>
  </div>
  <div class="resource-tray-card-evidence">
    <ng-content select="[tray-card-evidence]"></ng-content>
  </div>
</article>
